import $ from 'jquery';
import 'jquery-ui';
import '../orgchart/primitives';
import '../styles/primitives.css';

// source: https://www.basicprimitives.com/index.php?option=com_content&view=article&id=11&Itemid=10&lang=en
export const generateEmployeeTemplate = (template) => {
  const elementString =
    `<div class="bp-item bp-corner-all bt-item-frame ${template.name}Container">
      <div name="title" class=" bp-item bp-title ${template.name}Title"  style="top: 10px; left: 10px; width: 190px; height: 18px; font-size: 16px" />
      <div class="imageContainer bp-item bp-photo-frame">
        <div class="material-icons bp-item" style="height: 70px; width: 56px; color: rgba(0, 0, 0, 0.541176); font-size: 64px;">person</div>
      </div>
      <div class="bp-item material-icons employeeIcon" style="top: 32px;">phone</div>
      <div name="phone" class="bp-item employeeInfo" style="top: 32px; height: 18px;" />
      <div class="bp-item material-icons employeeIcon" style="top: 52px;">mail</div>
      <div name="email" class="bp-item employeeInfo" style="top: 52px; height: 18px;"/>
      <div class="bp-item material-icons employeeIcon" style="top: 72px;">description</div>
      <div name="description" class="bp-item employeeInfo" style="top: 72px; height: 30px; word-wrap: break-word;" />
    </div>`;
  const itemTemplate = $(elementString).css({
    width: template.itemSize.width + "px",
    height: template.itemSize.height + "px"
  }).addClass("bp-item bp-corner-all bt-item-frame");
  return itemTemplate.wrap('<div>').parent().html();
};

export const generateCompanyTemplate = (template, iconName) => {
  let elementString =
    `<div class="bp-item bp-corner-all bt-item-frame ${template.name}Container">
      <div name="title" class="bp-item bp-title ${template.name}Title"  style="top: 10px; left: 10px; width: 135px; height: 18px; font-size: 16px" />
      <div class="imageContainer bp-item bp-photo-frame">
        <div class="material-icons bp-item" style="height: 41px; width: 41px; color: rgba(0, 0, 0, 0.541176); font-size: 40px;">${iconName}</div>
      </div>
    </div>`;
  const itemTemplate = $(elementString).css({
    width: template.itemSize.width + "px",
    height: template.itemSize.height + "px"
  }).addClass("bp-item bp-corner-all bt-item-frame-2");
  return itemTemplate.wrap('<div>').parent().html();
};

export const generateHighlightTemplate = (template) => {
  return $('<div></div>').css({
    position: 'absolute',
    overflow: 'visible',
    width: (template.itemSize.width + template.highlightPadding.left + template.highlightPadding.right) + "px",
    height: (template.itemSize.height + template.highlightPadding.top + template.highlightPadding.bottom) + "px",
    'box-shadow': 'rgba(0, 0, 0, 0.3) 0px 3px 10px',
    "border-width": "0px",
    'font-color': 'white',
  }).addClass('bp-item2 bp-corner-all').wrap('<div>').parent().html();
}

export const generateCompanyHighlightTemplate = (template) => {
  return $('<div></div>').css({
    position: 'absolute',
    overflow: 'visible',
    width: (template.itemSize.width + template.highlightPadding.left + template.highlightPadding.right) + "px",
    height: (template.itemSize.height + template.highlightPadding.top + template.highlightPadding.bottom) + "px",
    'box-shadow': 'rgba(0, 0, 0, 0.0) 0px 3px 10px',
    "border-width": "0px",
  }).addClass('bt-item-frame').wrap('<div>').parent().html();
}
export const generateCompanyCursorTemplate = (template) => {
  return $('<div></div>').css({
    position: 'absolute',
    overflow: 'visible',
    width: (template.itemSize.width + template.highlightPadding.left + template.highlightPadding.right) + "px",
    height: (template.itemSize.height + template.highlightPadding.top + template.highlightPadding.bottom) + "px",
    'box-shadow': 'rgba(0, 0, 0, 0.0) 0px 3px 10px',
    "border-width": "0px",
  }).addClass('').wrap('<div>').parent().html();
}
export default generateEmployeeTemplate;



// WEBPACK FOOTER //
// ./src/utils/orgChart.js